export const neutral = {
  50: "#FFFFFF",
  75: "#F8F8F8",
  100: "#F0F0F0",
  200: "#CCCCCC",
  300: "#999999",
  400: "#666666",
  500: "#333333",
  550: "#1A1A1A",
  600: "#000000",
};

export const red = {
  50: "#B82647",
  300: "#9C2641",
  600: "#782437",
};

export const blue = {
  50: "#DFE2FF",
  200: "#2E3793",
  500: "#161E69",
  700: "#0B0F36",
};

export const yellow = {
  100: "#F4E4C1",
  400: "#e4c580",
};

export const green = {
  50: "#cbf8e8ff",
  100: "#19cf8e",
  400: "#15DB95",
};

export const colors = {
  error: "red.500",
};

export const fontColorLight = "white";
export const fontColorDark = "black";
export const cardBackgroundColor = neutral[100];
